import { I18n } from '@calendly/i18n'

import { useInScope } from 'hooks/meetings/use_in_scope'

import { DropdownFilter } from './dropdown/dropdown_filter'
import { FilterLayout } from './filter_layout'

export const TeamsSelect = ({ params, onApply, useColumnLayout = false }) => {
  const inScope = useInScope('team')

  if (!inScope) return null

  const controlText = params.team_ids.length === 0
    ? I18n.t('publisher.dashboard.filters.label.team_all')
    : I18n.t('publisher.dashboard.filters.label.team', { count: params.team_ids.length })

  const applySelectedIds = (values) => {
    onApply({
      ...params,
      team_ids: values?.team_0 || []
    })
  }

  return (
    <FilterLayout
      label={I18n.t('publisher.labels.team')}
      useColumnLayout={useColumnLayout}
    >
      <DropdownFilter
        name="team"
        params={params}
        showHeader
        showSearchInput
        onApply={applySelectedIds}
        controlText={controlText}
      />
    </FilterLayout>
  )
}
